"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _class, _descriptor, _temp;

var MessageStream = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(MessageStream, _Component);

  function MessageStream() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, MessageStream);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(MessageStream)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "profile", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      messageStream: _this.profile.messageStream
    };
    return _this;
  }

  babelHelpers.createClass(MessageStream, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.profile != this.props.profile) {
        this.setState({
          messageStream: this.props.profile.messageStream
        });
      }
    }
  }, {
    key: "setValue",
    value: function setValue(event) {
      this.setState({
        messageStream: event.target.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        "data-field": "messageStream",
        className: "form-group"
      }, _react.default.createElement("label", {
        htmlFor: "messageStream"
      }, "Site Notifications"), _react.default.createElement("div", {
        className: "select-wrap"
      }, _react.default.createElement("select", {
        id: "messageStream",
        name: "messageStream",
        onChange: this.setValue,
        value: this.state.messageStream,
        size: "1",
        className: "form-control input-lg"
      }, _react.default.createElement("option", {
        value: "hourly"
      }, "Send hourly"), _react.default.createElement("option", {
        value: "daily"
      }, "Send daily"), _react.default.createElement("option", {
        value: "none"
      }, "Do not send")), _react.default.createElement("span", null)), _react.default.createElement("div", {
        className: "form-group-help"
      }, "Receive email notifications when there are replies to your comments and other activity related to your account."));
    }
  }]);
  return MessageStream;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "profile", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "setValue", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setValue"), _class.prototype)), _class);
var _default = MessageStream;
exports.default = _default;